/**
 * 값 반영 결과 토스트 — 값 채우기 버튼과 수동 붙여넣기가 같은 문구·같은 모양을 쓴다.
 *
 * Figma Toast 7160-523813(모두 반영) / 7160-523814(일부 반영).
 * "모두 반영"은 안 들어간 항목이 하나도 없을 때만 쓴다 — 어떤 경로로 빠졌든
 * 사용자 눈에는 똑같이 "안 들어간 것"이라 호출부가 합쳐서 넘긴다.
 */
import { toast } from "sonner";

const PartialApplyToastIcon = () => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="8" fill="currentColor" />
    <circle cx="10" cy="10" r="5.25" stroke="white" strokeWidth="1.25" />
    <path
      d="M10 6.75V10.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="10" cy="13" r="0.75" fill="white" />
  </svg>
);

export const toastApplyResult = ({
  applied,
  notApplied,
  description,
}: {
  /** 실제로 값이 바뀐 항목 수 */
  applied: number;
  /** 어떤 이유로든 반영되지 않은 항목 수 */
  notApplied: number;
  description?: React.ReactNode;
}) => {
  if (notApplied > 0) {
    // 미반영 상세는 행 배지와 셀 하이라이트가 안내하므로 별도 에러 토스트는 띄우지 않는다.
    toast.warning(
      `${applied}개 항목이 반영되었습니다. 반영되지 않은 ${notApplied}개 항목을 확인해주세요.`,
      {
        icon: <PartialApplyToastIcon />,
        // 기본 356px 폭 대신 문구 길이만큼만 넓히고, 화면이 좁을 때는 줄바꿈을 허용한다.
        style: {
          width: "max-content",
          maxWidth: "calc(100vw - 32px)",
          left: "50%",
          translate: "-50% 0",
        },
        classNames: {
          title: "whitespace-nowrap max-[600px]:whitespace-normal",
        },
        ...(description ? { description } : {}),
      },
    );
    return;
  }
  toast.success(
    `${applied}개 항목이 모두 반영되었습니다.`,
    description ? { description } : undefined,
  );
};
